/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AuthenticateWithFirebase200Response,
  AuthenticateWithFirebaseRequest,
  CreateUserRequest,
  ListUsersInCompanyResponse,
  Problem,
  RegisterUser201Response,
  RegisterUserRequest,
  UpdateUserRequest,
  User,
} from '../models/index';
import {
    AuthenticateWithFirebase200ResponseFromJSON,
    AuthenticateWithFirebase200ResponseToJSON,
    AuthenticateWithFirebaseRequestFromJSON,
    AuthenticateWithFirebaseRequestToJSON,
    CreateUserRequestFromJSON,
    CreateUserRequestToJSON,
    ListUsersInCompanyResponseFromJSON,
    ListUsersInCompanyResponseToJSON,
    ProblemFromJSON,
    ProblemToJSON,
    RegisterUser201ResponseFromJSON,
    RegisterUser201ResponseToJSON,
    RegisterUserRequestFromJSON,
    RegisterUserRequestToJSON,
    UpdateUserRequestFromJSON,
    UpdateUserRequestToJSON,
    UserFromJSON,
    UserToJSON,
} from '../models/index';

export interface AuthenticateWithFirebaseOperationRequest {
    authenticateWithFirebaseRequest: AuthenticateWithFirebaseRequest;
}

export interface CreateUserOperationRequest {
    createUserRequest: CreateUserRequest;
}

export interface DeleteUserRequest {
    userId: number;
}

export interface GetUserRequest {
    userId: number;
}

export interface GetUsersByCompanyRequest {
    companyId: number;
}

export interface RegisterUserOperationRequest {
    registerUserRequest: RegisterUserRequest;
}

export interface UpdateUserOperationRequest {
    userId: number;
    updateUserRequest: UpdateUserRequest;
}

/**
 * UsersApi - interface
 * 
 * @export
 * @interface UsersApiInterface
 */
export interface UsersApiInterface {
    /**
     * This login endpoint is intentionally unauthenticated. Send the Firebase ID token in the JSON request body as `idToken`; do not send it in the bearer authorization header for this operation. 
     * @summary Exchange a Firebase ID token for the TurboClaim user profile
     * @param {AuthenticateWithFirebaseRequest} authenticateWithFirebaseRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    authenticateWithFirebaseRaw(requestParameters: AuthenticateWithFirebaseOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthenticateWithFirebase200Response>>;

    /**
     * This login endpoint is intentionally unauthenticated. Send the Firebase ID token in the JSON request body as `idToken`; do not send it in the bearer authorization header for this operation. 
     * Exchange a Firebase ID token for the TurboClaim user profile
     */
    authenticateWithFirebase(requestParameters: AuthenticateWithFirebaseOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthenticateWithFirebase200Response>;

    /**
     * 
     * @summary Create a user
     * @param {CreateUserRequest} createUserRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    createUserRaw(requestParameters: CreateUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>>;

    /**
     * Create a user
     */
    createUser(requestParameters: CreateUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User>;

    /**
     * 
     * @summary Delete a user by id
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    deleteUserRaw(requestParameters: DeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete a user by id
     */
    deleteUser(requestParameters: DeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getCurrentUserRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>>;

    /**
     * Get the current user
     */
    getCurrentUser(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User>;

    /**
     * 
     * @summary Get a user by id
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getUserRaw(requestParameters: GetUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>>;

    /**
     * Get a user by id
     */
    getUser(requestParameters: GetUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User>;

    /**
     * 
     * @summary Get users by company
     * @param {number} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    getUsersByCompanyRaw(requestParameters: GetUsersByCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListUsersInCompanyResponse>>;

    /**
     * Get users by company
     */
    getUsersByCompany(requestParameters: GetUsersByCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListUsersInCompanyResponse>;

    /**
     * Creates a TurboClaim user for the Firebase-authenticated caller. The request body currently includes a legacy `role` field, but the runtime always persists the new user as `owner`. The Firebase ID token must be sent in the standard bearer authorization header. 
     * @summary Self-register the authenticated Firebase user as a company owner
     * @param {RegisterUserRequest} registerUserRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    registerUserRaw(requestParameters: RegisterUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RegisterUser201Response>>;

    /**
     * Creates a TurboClaim user for the Firebase-authenticated caller. The request body currently includes a legacy `role` field, but the runtime always persists the new user as `owner`. The Firebase ID token must be sent in the standard bearer authorization header. 
     * Self-register the authenticated Firebase user as a company owner
     */
    registerUser(requestParameters: RegisterUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RegisterUser201Response>;

    /**
     * 
     * @summary Update a user by id
     * @param {number} userId 
     * @param {UpdateUserRequest} updateUserRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    updateUserRaw(requestParameters: UpdateUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>>;

    /**
     * Update a user by id
     */
    updateUser(requestParameters: UpdateUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User>;

}

/**
 * 
 */
export class UsersApi extends runtime.BaseAPI implements UsersApiInterface {

    /**
     * This login endpoint is intentionally unauthenticated. Send the Firebase ID token in the JSON request body as `idToken`; do not send it in the bearer authorization header for this operation. 
     * Exchange a Firebase ID token for the TurboClaim user profile
     */
    async authenticateWithFirebaseRaw(requestParameters: AuthenticateWithFirebaseOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthenticateWithFirebase200Response>> {
        if (requestParameters['authenticateWithFirebaseRequest'] == null) {
            throw new runtime.RequiredError(
                'authenticateWithFirebaseRequest',
                'Required parameter "authenticateWithFirebaseRequest" was null or undefined when calling authenticateWithFirebase().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/users/auth/firebase`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AuthenticateWithFirebaseRequestToJSON(requestParameters['authenticateWithFirebaseRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthenticateWithFirebase200ResponseFromJSON(jsonValue));
    }

    /**
     * This login endpoint is intentionally unauthenticated. Send the Firebase ID token in the JSON request body as `idToken`; do not send it in the bearer authorization header for this operation. 
     * Exchange a Firebase ID token for the TurboClaim user profile
     */
    async authenticateWithFirebase(requestParameters: AuthenticateWithFirebaseOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthenticateWithFirebase200Response> {
        const response = await this.authenticateWithFirebaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a user
     */
    async createUserRaw(requestParameters: CreateUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>> {
        if (requestParameters['createUserRequest'] == null) {
            throw new runtime.RequiredError(
                'createUserRequest',
                'Required parameter "createUserRequest" was null or undefined when calling createUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/users`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUserRequestToJSON(requestParameters['createUserRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * Create a user
     */
    async createUser(requestParameters: CreateUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User> {
        const response = await this.createUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a user by id
     */
    async deleteUserRaw(requestParameters: DeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling deleteUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/users/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a user by id
     */
    async deleteUser(requestParameters: DeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteUserRaw(requestParameters, initOverrides);
    }

    /**
     * Get the current user
     */
    async getCurrentUserRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/users/me`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * Get the current user
     */
    async getCurrentUser(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User> {
        const response = await this.getCurrentUserRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get a user by id
     */
    async getUserRaw(requestParameters: GetUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/users/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * Get a user by id
     */
    async getUser(requestParameters: GetUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User> {
        const response = await this.getUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get users by company
     */
    async getUsersByCompanyRaw(requestParameters: GetUsersByCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListUsersInCompanyResponse>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getUsersByCompany().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/users/company/{companyId}`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListUsersInCompanyResponseFromJSON(jsonValue));
    }

    /**
     * Get users by company
     */
    async getUsersByCompany(requestParameters: GetUsersByCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListUsersInCompanyResponse> {
        const response = await this.getUsersByCompanyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a TurboClaim user for the Firebase-authenticated caller. The request body currently includes a legacy `role` field, but the runtime always persists the new user as `owner`. The Firebase ID token must be sent in the standard bearer authorization header. 
     * Self-register the authenticated Firebase user as a company owner
     */
    async registerUserRaw(requestParameters: RegisterUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RegisterUser201Response>> {
        if (requestParameters['registerUserRequest'] == null) {
            throw new runtime.RequiredError(
                'registerUserRequest',
                'Required parameter "registerUserRequest" was null or undefined when calling registerUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("firebaseBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/users/register`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RegisterUserRequestToJSON(requestParameters['registerUserRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegisterUser201ResponseFromJSON(jsonValue));
    }

    /**
     * Creates a TurboClaim user for the Firebase-authenticated caller. The request body currently includes a legacy `role` field, but the runtime always persists the new user as `owner`. The Firebase ID token must be sent in the standard bearer authorization header. 
     * Self-register the authenticated Firebase user as a company owner
     */
    async registerUser(requestParameters: RegisterUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RegisterUser201Response> {
        const response = await this.registerUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a user by id
     */
    async updateUserRaw(requestParameters: UpdateUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling updateUser().'
            );
        }

        if (requestParameters['updateUserRequest'] == null) {
            throw new runtime.RequiredError(
                'updateUserRequest',
                'Required parameter "updateUserRequest" was null or undefined when calling updateUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/users/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserRequestToJSON(requestParameters['updateUserRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * Update a user by id
     */
    async updateUser(requestParameters: UpdateUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User> {
        const response = await this.updateUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
